import { formatUrl } from './base';

// GET: /respondent_surveys/[id]/music?ref=[reference] - music survey

function updateRespondentSurveyPlaylistMusic(id, data) {
	const url = formatUrl({
		pathname: `respondent_survey_playlists/${id}`
	});

	return fetch(url, {
		method: 'PUT',
		body: JSON.stringify(data),
		headers: {
			'Accept': 'application/json',
    		'Content-Type': 'application/json'
		}
	}).then((response) => {
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response.json();
	});
}

export { updateRespondentSurveyPlaylistMusic }


// WEBPACK FOOTER //
// ./src/api/respondentsurveyplaylistapi.js